import React, { useState, useContext } from 'react'
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import Contact from './Contact'
import Works from './Works'
import Personal from './Personal'
import { ThemeParent } from '../Context/ThemeContext'
import { abrimg } from '../Assets/index'

export default function Parent() {
    const { theme } = useContext(ThemeParent);
    const [activeTab, setActiveTab] = useState('1')
    const setAcriveTab = (tab: string) => {
        if (activeTab !== tab) setActiveTab(tab)
    }
    return (
        <div>
            {/* Simple text header with circular image */}
            <div style={{ borderBottom: '1px solid currentColor', marginBottom: '20px', paddingBottom: '10px', display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <img
                    src={abrimg}
                    alt="Abraham T. Workie"
                    style={{
                        width: '100px',
                        height: '100px',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        objectPosition: 'center 100%',
                        border: '2px solid currentColor'
                    }}
                />
                <div>
                    <h1 style={{ margin: 0 }}>Abraham T. Workie</h1>
                    <p style={{ margin: '5px 0' }}>Software Engineer</p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        Virginia, USA | <a href="mailto:abrahamterfie4563@gmail.com">abrahamterfie4563@gmail.com</a> | <a href="mailto:aworkie@sharedspectrum.com">aworkie@sharedspectrum.com</a>
                    </p>
                    <p style={{ margin: '5px 0', fontSize: '14px' }}>
                        <a href="https://github.com/AbrahamTerfie" target="_blank" rel="noreferrer">GitHub</a>
                        {' | '}
                        <a href="https://www.linkedin.com/in/abraham-terfie/" target="_blank" rel="noreferrer">LinkedIn</a>
                    </p>
                </div>
            </div>

            {/* Navigation */}
            <div>
                <Nav className='d-flex flex-wrap' style={{ marginBottom: '20px' }}>
                    <NavItem>
                        <NavLink
                            style={activeTab === '1' ? { ...theme.activeTab, cursor: 'pointer' } : { ...theme.notActiveTab, cursor: 'pointer' }}
                            onClick={() => { setAcriveTab('1') }}>
                            [About]
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={activeTab === '2' ? { ...theme.activeTab, cursor: 'pointer' } : { ...theme.notActiveTab, cursor: 'pointer' }}
                            onClick={() => { setAcriveTab('2') }}>
                            [Work]
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            style={activeTab === '3' ? { ...theme.activeTab, cursor: 'pointer' } : { ...theme.notActiveTab, cursor: 'pointer' }}
                            onClick={() => { setAcriveTab('3') }}>
                            [Contact]
                        </NavLink>
                    </NavItem>
                </Nav>

                <hr style={{ margin: '0 0 20px 0' }} />

                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Personal />
                    </TabPane>
                    <TabPane tabId="2">
                        <Works />
                    </TabPane>
                    <TabPane tabId="3">
                        <Contact />
                    </TabPane>
                </TabContent>
            </div>
        </div>
    )
}
